import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=38e30ff6&scoped=true&"
import script from "./AddArticle.vue?vue&type=script&lang=js&"
export * from "./AddArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=38e30ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e30ff6",
  null
  
)

export default component.exports